import { defineMessages, useIntl } from 'react-intl-next';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const i18n = defineMessages({
	noEditAccessFlagTitle: {
		id: 'edit-features.no-edit-access-flag.title',
		defaultMessage: 'This shortcut requires edit access',
		description:
			'Title for the flag that displays when user tries to edit the page without edit access',
	},
	noEditAccessFlagDescription: {
		id: 'edit-features.no-edit-access-flag.description',
		defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content.",
		description: 'This message appears when user tries to edit the page without edit access',
	},
});

export const useNoEditAccessFlag = (flags: FlagsStateContainer) => {
	const intl = useIntl();

	const showNoEditAccessFlag = () => {
		void flags.showFlag({
			id: 'live-pages-mode-flag',
			title: intl.formatMessage(i18n.noEditAccessFlagTitle),
			description: intl.formatMessage(i18n.noEditAccessFlagDescription),
			close: 'auto',
		});
	};

	return { showNoEditAccessFlag };
};
